import { api } from "./api";

export const SupportApi = (params) => {
  return api.post(
    "/distributor/support/create",
    JSON.stringify(params)
  );
};
